import styled, { ITheme } from '../../theme'
import { IWithSize } from '../../containers/BookingCalendar/Calendar/Calendar'

const HeaderLabel = styled.div<IWithSize>`
  font-size: ${({ size }) => (size ? 14 * size : 14)}px;
  font-weight: bold;
  letter-spacing: 0.14px;
  color: ${(props: ITheme) => props.theme.colors.palette.darkGreyTwo};
`

export default HeaderLabel
